import {ThemeOptions, alpha} from '@mui/material/styles';
import {merge} from 'lodash';
import {themePoppins} from './themePoppins';
import {aeroGradients} from './aeroTheme.utils';

const cfg = window.themeColors as any; // TODO make type

export const generateMuiTheme = (mode: 'light' | 'dark'): ThemeOptions => {
   const isDark = mode === 'dark';

   const bg = isDark ? cfg.background.dark : cfg.background.light;
   const text = isDark ? cfg.text.dark : cfg.text.light;

   return merge({}, themePoppins, {
      palette: {
         mode,

         primary: {main: cfg.brand.primary},
         secondary: {main: cfg.brand.secondary},

         success: {main: cfg.status.success},
         warning: {main: cfg.status.warning},
         error: {main: cfg.status.error},
         info: {main: cfg.status.info},

         background: {
            default: bg.base,
            paper: alpha(bg.surface, isDark ? 0.75 : 1),
         },

         text: {
            primary: text.primary,
            secondary: text.secondary,
         },

         divider: isDark ? alpha('#ffffff', 0.08) : alpha('#000000', 0.08),
      },

      shape: {
         borderRadius: cfg.radius,
      },

      typography: {
         fontFamily: cfg.fonts.family,

         h1: {fontWeight: cfg.fonts.headings.h1},
         h2: {fontWeight: cfg.fonts.headings.h2},
         h3: {fontWeight: cfg.fonts.headings.h3},
      },

      components: {
         MuiCssBaseline: {
            styleOverrides: {
               body: {
                  color: text.primary,
                  backgroundColor: bg.base,
               },

               'body::before': isDark
                  ? {
                       content: '""',
                       position: 'fixed',
                       inset: 0,
                       zIndex: -1,
                       backgroundImage: `
                  ${aeroGradients.glowRadial(cfg.brand.primary, 0.15, '40% 20%')},
                  ${aeroGradients.glowRadial(cfg.brand.secondary, 0.1, '80% 0%')},
                  ${aeroGradients.glowRadial(cfg.brand.accent, 0.08, '0% 50%')}
                `,
                       backgroundRepeat: 'no-repeat',
                       backgroundSize: 'cover',
                       pointerEvents: 'none',
                    }
                  : {},
            },
         },

         MuiPaper: {
            styleOverrides: {
               root: {
                  backdropFilter: isDark ? 'blur(12px)' : 'none',
                  backgroundImage: isDark ? aeroGradients.panel(bg.surface) : 'none',
                  border: `1px solid ${isDark ? alpha('#ffffff', 0.08) : alpha('#000000', 0.06)}`,
               },
            },
         },

         MuiButton: {
            styleOverrides: {
               root: {
                  borderRadius: 6,
                  textTransform: 'none',
                  fontWeight: cfg.fonts.weights.semibold,
                  transition: 'all 0.25s ease',

                  '&:hover': {
                     transform: 'translateY(-2px)',
                     boxShadow: `0 4px 12px ${alpha(cfg.brand.primary, 0.25)}`,
                  },

                  '&:active': {
                     transform: 'translateY(0px) scale(0.98)',
                  },
               },
            },
         },
      },
   });
};
